import { request } from '@/lib/http'

/**
 * @returns {Promise<Array<Object>>}
 */
export function fetchAll () {
  return request({
    url: 'permission',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `permission`,
    method: 'get',
    params: queriesParams
  })
}

/**
 * @param {Number} id
 * @returns {Promise<Object>}
 */
export function show (id) {
  return request({
    url: `permission/${id}`,
    method: 'get'
  })
}

/**
 * @param {Object} data
 * @param {String} data.name
 * @param {String} data.tag
 * @param {Boolean} data.isPublic
 * @returns {Promise<Object>}
 */
export function add (data) {
  return request({
    url: 'permission',
    method: 'post',
    data
  })
}

/**
 * @param {Number} id
 * @param {Object} data
 * @param {String} data.name
 * @param {String} data.tag
 * @param {Boolean} data.isPublic
 * @returns {Promise<Object>}
 */
export function edit (id, data) {
  return request({
    url: `permission/${id}`,
    method: 'patch',
    data
  })
}
